isStatefulPromise